module.exports = __webpack_public_path__ + "static/logo_black-2bc96d4a82dc3f1eeb1bb5c72fdff2bd.png";